<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid>
        <v-row style="min-width: 500px">
          <v-col>
            <template>
              <v-data-table
                :headers="headers"
                :items="items"
                disable-filtering
                disable-pagination
                hide-default-footer
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>スタッフ情報メンテ</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-dialog v-model="dialog" fullscreen max-width="500px">
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark class="mb-2" v-on="on"
                          >新規追加</v-btn
                        >
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container grid-list-md>
                            <v-row>
                              <v-col xs="12" sm="4" md="4">
                                <v-text-field
                                  v-model="editedItem.staffname"
                                  label="スタッフ苗字"
                                ></v-text-field>
                              </v-col>
                              <v-col xs="12" sm="4" md="4">
                                <v-text-field
                                  v-model="editedItem.staffuname"
                                  label="スタッフ名前"
                                ></v-text-field>
                              </v-col>
                              <v-col xs="12" sm="4" md="4">
                                <v-text-field
                                  v-model="editedItem.username"
                                  label="ユーザーID"
                                ></v-text-field>
                              </v-col>
                              <v-col xs="12" sm="4" md="4">
                                <v-text-field
                                  type="password"
                                  v-model="editedItem.password"
                                  label="パスワード"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" xs="4" sm="4" md="4">
                                <v-select
                                  v-model="editedItem.role"
                                  :items="roles"
                                  item-text="text"
                                  item-value="value"
                                  label="スタッフ権限"
                                ></v-select>
                              </v-col>

                              <v-col xs="12" sm="4" md="4">
                                <v-text-field
                                  v-model="editedItem.hyoji"
                                  label="表示順位"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn class="error" @click="close">キャンセル</v-btn>
                          <v-btn class="success" @click="save">保存</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-icon @click="editItem(item)">create</v-icon>
                  <v-icon @click="deleteItem(item)">delete</v-icon>
                </template>
                <template v-slot:no-data></template>
              </v-data-table>
            </template>

            <v-snackbar v-model="snackbar" color="success" :timeout="2000">
              {{ msg }}
              <v-btn @click="snackbar = false">閉じる</v-btn>
            </v-snackbar>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Common from "@/components/Common";
export default {
  mixins: [Common],
  data: () => ({
    dialog: false,
    headers: [
      { text: "スタッフ苗字", value: "staffname" },
      { text: "スタッフ名前", value: "staffuname" },
      { text: "ユーザーID", value: "username" },
      { text: "スタッフ権限", value: "role" },
      { text: "表示順位", value: "hyoji" },
      { text: "編集/削除", value: "actions", sortable: false }
    ],
    roles: [
      { text: "管理者", value: "admin" },
      { text: "管理者サブ権限", value: "adminsub" },
      { text: "常勤", value: "jokin" },
      { text: "登録", value: "touroku" }
    ],
    items: [],
    editedIndex: -1,
    editedItem: {
      staffname: "",
      hyoji: 0,
      work: 0
    },
    defaultItem: {
      staffname: "",
      hyoji: 0,
      work: 0
    },
    msg: "",
    snackbar: ""
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新規追加" : "編集";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.kousin();
  },

  methods: {
    kousin() {
      var self = this;
      this.$axios
        .post(
          this.url + "staff.php",
          JSON.stringify({
            st: "get"
          })
        )
        .then(function(res) {
          self.items = res.data;
        });
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      const index = this.items.indexOf(item);
      confirm("削除してもよろしいですか？") && this.items.splice(index, 1);
      var self = this;
      this.$axios
        .post(
          this.url + "staff.php",
          JSON.stringify({
            st: "del",
            item: item
          })
        )
        .then(function() {
          self.msg = "削除完了しました。";
          self.snackbar = true;
          self.kousin();
          self.close();
        });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      var status = "upd";
      if (this.editedIndex > -1) {
        status = "upd";
      } else {
        status = "ins";
      }
      var self = this;
      this.$axios
        .post(
          this.url + "staff.php",
          JSON.stringify({
            st: status,
            item: this.editedItem
          })
        )
        .then(function() {
          self.msg = "更新完了しました。";
          self.snackbar = true;
          self.kousin();
          self.close();
        });
    }
  }
};
</script>

<style lang="stylus">
.application {
  width: 100%;
}
</style>
